/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * Loadable component for Labels Import
 *
 * @author Anton Panasenko
 * @author Aleksandr Perkhunov
 * @version 1.10.0
 * @since 1.3.0
 */

import loadable from '../../utils/loadable';

export default loadable(() => import(/* webpackChunkName: "PageLabelsImport" */ './components/LabelsImport'), undefined);
